import { APIGet, APIPost, APIPut, APIDelete, StatusCode, APIUrl, AdminType } from "api/protocols";
import axios, { CancelToken } from "axios";

import { TProductUnit } from "redux/reducers/models/product";

interface IGetProductUnit {
  id?: string | number;
  search?: string;
}

export async function GetProductUnits(params: IGetProductUnit, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet<TProductUnit[]>(APIUrl(AdminType.FacilityAdmin, "/product/unit"), params, useGlobalLoader, token);
}

interface IPostProductUnit {
  name: string;
  abbreviation?: string;
}

export async function PostProductUnit(params: IPostProductUnit, useGlobalLoader: boolean) {
  return await APIPost<TProductUnit>(APIUrl(AdminType.FacilityAdmin, "/product/unit"), params, useGlobalLoader);
}

interface IPutProductUnit {
  id: string | number;
  name?: string;
  abbreviation?: string;
}

export async function PutProductUnit(params: IPutProductUnit, useGlobalLoader: boolean) {
  return await APIPut<TProductUnit>(APIUrl(AdminType.FacilityAdmin, "/product/unit"), params, useGlobalLoader);
}

export async function DeleteProductUnit(params: { id: string | number }, useGlobalLoader: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/product/unit"), params, useGlobalLoader);
}
